import React from "react";
import { ConditionCard, ConditionCardProps } from "./ConditionCard";
import { useAttributeSuggestions } from "../../hooks/useEmployeeCache";

export const ConditionCardWithEmployees: React.FC<Omit<ConditionCardProps, "getSuggestionsFunc" | "getAvailableAttributePathsFunc" | "getAttributeConfigFunc">> = (props) => {
  const { getSuggestions, getAvailableAttributePaths, getAttributeConfig } = useAttributeSuggestions();

  return (
    <ConditionCard
      {...props}
      getSuggestionsFunc={getSuggestions}
      getAvailableAttributePathsFunc={getAvailableAttributePaths}
      getAttributeConfigFunc={getAttributeConfig}
    />
  );
};

